import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card mb-5" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "订单信息", -1)
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "table table-bordered" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "订单号", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "下单时间", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "商品类型", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("预售")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("现货")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "支付模式", -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "table table-bordered" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "商品原价", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "使用优惠券", -1)
const _hoisted_21 = { class: "ms-2 text-muted" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "优惠金额", -1)
const _hoisted_24 = { class: "text-danger" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "实付总额", -1)
const _hoisted_26 = { class: "text-danger fw-bold" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "订金金额", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "已付金额", -1)
const _hoisted_30 = { class: "text-success fw-bold" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "待付金额", -1)
const _hoisted_32 = { class: "text-warning" }
const _hoisted_33 = { class: "card mb-5" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "商品信息")
], -1)
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "mb-1" }
const _hoisted_39 = { class: "text-muted" }
const _hoisted_40 = { class: "card mb-5" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "用户信息")
], -1)
const _hoisted_42 = { class: "card-body" }
const _hoisted_43 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "用户昵称", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "手机号", -1)
const _hoisted_46 = { class: "card mb-5" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "收货信息")
], -1)
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "收货人", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "联系电话", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "收货地址", -1)
const _hoisted_53 = { colspan: "3" }
const _hoisted_54 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_55 = { class: "card mb-5" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "支付记录")
], -1)
const _hoisted_57 = { class: "card-body" }
const _hoisted_58 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", null, "支付类型"),
    /*#__PURE__*/_createElementVNode("th", null, "金额"),
    /*#__PURE__*/_createElementVNode("th", null, "余额抵扣"),
    /*#__PURE__*/_createElementVNode("th", null, "支付宝支付"),
    /*#__PURE__*/_createElementVNode("th", null, "支付时间")
  ])
], -1)
const _hoisted_60 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_61 = { class: "card mb-5" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "物流信息")
], -1)
const _hoisted_63 = { class: "card-body" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "table table-bordered" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "物流公司", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bold bg-light",
  width: "120"
}, "物流单号", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold bg-light" }, "发货时间", -1)
const _hoisted_69 = { colspan: "3" }
const _hoisted_70 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_71 = /*#__PURE__*/_createTextVNode("确认发货")
const _hoisted_72 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_73 = { class: "card mb-5" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "时间线")
], -1)
const _hoisted_75 = { class: "card-body" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "创建订单", -1)
const _hoisted_77 = { class: "text-muted" }
const _hoisted_78 = { class: "fw-bold" }
const _hoisted_79 = { class: "text-muted" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "商品到货通知", -1)
const _hoisted_81 = { class: "text-muted" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "支付尾款", -1)
const _hoisted_83 = { class: "text-muted" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "已发货", -1)
const _hoisted_85 = { class: "text-muted" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "订单完成", -1)
const _hoisted_87 = { class: "text-muted" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "订单取消", -1)
const _hoisted_89 = { class: "text-muted" }
const _hoisted_90 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "已退款", -1)
const _hoisted_92 = { class: "text-muted" }
const _hoisted_93 = { class: "d-flex justify-content-end" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("返回列表")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_tag, {
            type: _ctx.getStatusType(_ctx.order.status),
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.order.status_text), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, _toDisplayString(_ctx.order.order_no), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _createElementVNode("td", null, _toDisplayString(_ctx.order.created_at), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", null, [
                    (_ctx.order.is_presale)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "warning",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          type: "success",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_15,
                  _createElementVNode("td", null, _toDisplayString(_ctx.order.payment_mode === 'full' ? '全款' : '订金'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(_ctx.order.original_amount)), 1)
                ]),
                (_ctx.order.coupon_info)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          type: "warning",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.order.coupon_info.name), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.order.coupon_info.discount_text), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.order.discount_amount && parseFloat(_ctx.order.discount_amount) > 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("td", _hoisted_24, "-" + _toDisplayString(_ctx.formatPrice(_ctx.order.discount_amount)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_25,
                  _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatPrice(_ctx.order.total_amount)), 1)
                ]),
                (_ctx.order.is_presale && _ctx.order.payment_mode === 'deposit')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(_ctx.order.deposit_amount)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_29,
                  _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.formatPrice(_ctx.order.paid_amount)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_31,
                  _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.formatPrice(_ctx.remainingAmount)), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        (_ctx.order.product_snapshot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("img", {
                src: _ctx.order.product_snapshot.image,
                style: {"width":"80px","height":"80px","object-fit":"cover","border-radius":"8px"},
                class: "me-4"
              }, null, 8, _hoisted_37),
              _createElementVNode("div", null, [
                _createElementVNode("h5", _hoisted_38, _toDisplayString(_ctx.order.product_snapshot.name), 1),
                _createElementVNode("div", _hoisted_39, " 单价: " + _toDisplayString(_ctx.formatPrice(_ctx.order.unit_price)) + " x " + _toDisplayString(_ctx.order.quantity), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, [
        (_ctx.order.user)
          ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_44,
                  _createElementVNode("td", null, _toDisplayString(_ctx.order.user.nickname), 1),
                  _hoisted_45,
                  _createElementVNode("td", null, _toDisplayString(_ctx.order.user.mobile), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _hoisted_47,
      _createElementVNode("div", _hoisted_48, [
        (_ctx.order.address_snapshot)
          ? (_openBlock(), _createElementBlock("table", _hoisted_49, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_50,
                  _createElementVNode("td", null, _toDisplayString(_ctx.order.address_snapshot.name), 1),
                  _hoisted_51,
                  _createElementVNode("td", null, _toDisplayString(_ctx.order.address_snapshot.mobile), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_52,
                  _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.order.address_snapshot.area) + " " + _toDisplayString(_ctx.order.address_snapshot.detail), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_54, "暂无收货信息"))
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _hoisted_56,
      _createElementVNode("div", _hoisted_57, [
        (_ctx.paidPayments && _ctx.paidPayments.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paidPayments, (payment) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: payment.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(payment.payment_type === 'deposit' ? '订金' : (payment.payment_type === 'final' ? '尾款' : '全款')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(payment.amount)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(payment.balance_used)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(payment.alipay_amount)), 1),
                    _createElementVNode("td", null, _toDisplayString(payment.paid_at || '-'), 1)
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_60, "暂无支付记录"))
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _hoisted_62,
      _createElementVNode("div", _hoisted_63, [
        (_ctx.order.shipment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createElementVNode("table", _hoisted_65, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_66,
                    _createElementVNode("td", null, _toDisplayString(_ctx.order.shipment.shipping_company), 1),
                    _hoisted_67,
                    _createElementVNode("td", null, _toDisplayString(_ctx.order.shipment.tracking_no), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_68,
                    _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.order.shipment.shipped_at), 1)
                  ])
                ])
              ])
            ]))
          : (_ctx.order.status === 'pending_shipment')
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _createVNode(_component_el_form, {
                  model: _ctx.shipForm,
                  "label-width": "100px",
                  inline: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "物流公司" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.shipForm.shipping_company,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shipForm.shipping_company) = $event)),
                          placeholder: "请选择物流公司"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "顺丰速运",
                              value: "顺丰速运"
                            }),
                            _createVNode(_component_el_option, {
                              label: "中通快递",
                              value: "中通快递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "圆通快递",
                              value: "圆通快递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "韵达快递",
                              value: "韵达快递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "申通快递",
                              value: "申通快递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "极兔速递",
                              value: "极兔速递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "邮政快递",
                              value: "邮政快递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "京东物流",
                              value: "京东物流"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "物流单号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.shipForm.tracking_no,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shipForm.tracking_no) = $event)),
                          placeholder: "请输入物流单号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.onShip,
                          loading: _ctx.shipping
                        }, {
                          default: _withCtx(() => [
                            _hoisted_71
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_72, "暂无物流信息"))
      ])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _hoisted_74,
      _createElementVNode("div", _hoisted_75, [
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            (_ctx.order.created_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 0,
                  timestamp: "",
                  placement: "top",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_76,
                    _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.order.created_at), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.order.paid_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 1,
                  timestamp: "",
                  placement: "top",
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.order.payment_mode === 'deposit' ? '支付订金' : '支付完成'), 1),
                    _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.order.paid_at), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.order.arrival_notified_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 2,
                  timestamp: "",
                  placement: "top",
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _hoisted_80,
                    _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.order.arrival_notified_at), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.order.final_paid_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 3,
                  timestamp: "",
                  placement: "top",
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.order.final_paid_at), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.order.shipped_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 4,
                  timestamp: "",
                  placement: "top",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.order.shipped_at), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.order.completed_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 5,
                  timestamp: "",
                  placement: "top",
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_86,
                    _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.order.completed_at), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.order.cancelled_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 6,
                  timestamp: "",
                  placement: "top",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_88,
                    _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.order.cancelled_at), 1),
                    (_ctx.order.cancel_reason)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_90, "原因: " + _toDisplayString(_ctx.order.cancel_reason), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.order.refunded_at)
              ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: 7,
                  timestamp: "",
                  placement: "top",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_91,
                    _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.order.refunded_at), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _createVNode(_component_el_button, { onClick: _ctx.onBack }, {
        default: _withCtx(() => [
          _hoisted_94
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}